// Mapping role names to icons
export const getRoleIcon = (roleName: string) => {
  const name = roleName.toLowerCase()

  if (name.includes('super admin') || name.includes('admin')) {
    return 'tabler-crown'
  }

  if (name.includes('hr')) {
    return 'tabler-user'
  }

  if (name.includes('finance')) {
    return 'tabler-building-bank'
  }

  if (name.includes('employer')) {
    return 'tabler-device-analytics'
  }

  // Default icon
  return 'tabler-user-circle'
}

// Mapping role names to colors
export const getRoleColor = (roleName: string) => {
  const name = roleName.toLowerCase()

  if (name.includes('super admin') || name.includes('admin') || name.includes('master')) {
    return '#1976d2' // Blue
  }

  if (name.includes('hr')) {
    return '#ff9800' // Orange
  }

  if (name.includes('finance')) {
    return '#4caf50' // Green
  }

  if (name.includes('employer')) {
    return '#03a9f4' // Light blue
  }

  // Default color
  return '#757575' // Gray
}
